module.exports = __webpack_public_path__ + "static/media/ITS Banner 2320x120_0.9897a6e6.png";